import { Box, useMediaQuery } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import ProductValidationCreate from "pages/product_validation/ProductValidationCreate";
import ProductValidationList from "pages/product_validation/ProductValidationList";
import React from "react";
import { GrValidate } from "react-icons/gr";
import { MdAddBox } from "react-icons/md";

const ProductValidationManagement = () => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod={smallScreen ? "Validation" : "Product validation"}
        viewIcon={<GrValidate />}
        createIcon={<MdAddBox />}
        createChildren={<ProductValidationCreate />}
        listChildren={<ProductValidationList />}
      />
    </Box>
  );
};

export default ProductValidationManagement;
